import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const GPAXBuilderPage = lazy(() => import('../pages/gpax-builder/page'));
const GPAXTransformerPage = lazy(() => import('../pages/gpax-transformer/page'));
const WhyInfowarePage = lazy(() => import('../pages/why-infoware/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    index: true,
    element: <HomePage />,
  },
  {
    path: 'gpax-builder',
    element: <GPAXBuilderPage />,
  },
  {
    path: 'gpax-transformer',
    element: <GPAXTransformerPage />,
  },
  {
    path: 'why-infoware',
    element: <WhyInfowarePage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
